/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Search from "../../../Common/Search";
import Sorting from "../../../Common/Sorting";
import { connect } from "react-redux";
import { BiLoaderAlt } from "react-icons/bi";
import MetaHead from "../../../Common/Metahead";
import { NavLink } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import Paginations from "../../../Common/Pagination";
import { outReachList } from "../../../../stores/actions/outreach.actions.types";
import { sortingNameList } from "../../../../utilities/enums/index";
import OutReachTable from "../../../Tables/OutReachTable";

const OutreachList = (props) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState(""); // example filter if needed
  const [outreaches, setOutreaches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, total: 0 });
  const [sorting, setSorting] = useState([
    {
      whom: "updatedAt",
      order: "desc",
    },
  ]);

  useEffect(() => {
    setLoading(true);
    getOutreachList(search, pagination.page, sorting, status);
  }, [search, sorting, pagination.page, status]);

  const getOutreachList = (q = search, page, sort, status) => {
    const callback = (data) => {
      if (data.success) {
        const { total, pages, outreachList: list } = data?.data;
        setPagination((prev) => ({
          ...prev,
          total: total || 0,
          pages: pages || 1,
        }));
        setLoading(false);
        setOutreaches(list);
      }
    };

    const request = {
      callback,
      data: { q, page, sort, status },
    };
    props.outReachList(request);
  };

  const handleChangeSorting = (value) => {
    const sort = JSON.parse(value);
    setSorting([sort]);
  };

  const handleChangeStatus = (value) => {
    setStatus(value);
  };

  return (
    <div>
      <MetaHead title={t("outreach-list")} />
      <div className='flex flex-col sm:flex-row justify-end mb-3 gap-2'>
        <Search
          search={search}
          placeholder='Search by company, name, or email'
          setSearch={setSearch}
        />

        {/* Optional status filter */}
        {/* <Sorting
          name={"Status"}
          values={statusValues} 
          onChange={handleChangeStatus}
        /> */}

        <Sorting
          name={"Sort"}
          values={sortingNameList} // adapt as needed
          onChange={handleChangeSorting}
        />
        <div>
          <NavLink
            className='flex items-center justify-center h-8 border text-lg border-red-600 px-3 text-red-600'
            to='/outreach/add'
          >
            <FaPlus />
          </NavLink>
        </div>
      </div>
      {loading ? (
        <div className='flex dark:bg-boxdark bg-white items-center justify-center min-h-96'>
          <BiLoaderAlt className='animate-spin text-4xl text-primary dark:text-white' />
        </div>
      ) : (
        <div>
          <OutReachTable
            outreaches={outreaches}
            setOutreaches={setOutreaches}
          />
          <Paginations pagination={pagination} setPagination={setPagination} />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.app.visible,
});

export default connect(mapStateToProps, {
  outReachList,
})(OutreachList);
